import { TypeResponse } from 'gtd-ng-widget';

export class ProfileResponse extends TypeResponse {
  id: number;
  affiliate_id: number;
  affiliate: object;
  type: number;
  status: boolean;
  archived: boolean;
  content: string;
  created_at: number;
  updated_at: number;
  goal_type: {
    id: number;
    name: string;
  };
}
